import { createFileRoute } from "@tanstack/react-router";
import Partners from "@/pages/Partners";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/uk/partners/")({
  head: () => routeHead("/uk/partners/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Partners />
  );
}
